import type React from 'react';

import { observer } from 'mobx-react';

import z from 'z';

export interface IProps {}

const DMARCDialogDescription: React.FC<IProps> = observer(() => {
  return (
    <>
      Due to recent changes implemented by a number of email providers, we need you to make some
      changes to your email domain settings. This is needed to ensure that emails you send
      using&nbsp;
      {z.word('TM3')} are delivered to your customers and not incorrectly flagged as spam.
    </>
  );
});

DMARCDialogDescription.displayName = 'DMARCDialogDescription';

export default DMARCDialogDescription;
